export var brokingVolumeDetailsMapper = function (data) {
    var result = {};
    if (data) {
        result.brokTillDate = data.objBrok_TillDate;
        result.flmDetails = data.objFLM;
        result.ftyDetails = data.objFTY;
        result.revenueBrokingVol = data.objREVENUE_BROKING_BROK_VOL;
    }
    return result;
};
